module.exports = __webpack_public_path__ + "img/odnocl.7c584baa.svg";